const SUPPRESS_AUTH_ROUTE_LOADER_STATE_KEY = 'suppressAuthRouteLoader';

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null;

export const markAuthRouteLoaderSuppressed = (state?: unknown): Record<string, unknown> => ({
  ...(isRecord(state) ? state : {}),
  [SUPPRESS_AUTH_ROUTE_LOADER_STATE_KEY]: true,
});

export const shouldSuppressAuthRouteLoader = (state: unknown): boolean =>
  isRecord(state) && state[SUPPRESS_AUTH_ROUTE_LOADER_STATE_KEY] === true;
